import { BaseApiRouteService } from "mrb/core";

class NakiStoreFeaturedSectionFileStreamApiRouteService extends BaseApiRouteService {
    constructor() {
        super("store-naki-featured-section-file-streams");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?width,height}`, id, options);
    }

    getFeaturedSectionCoverImageByItemId(featuredSectionItemId, options) {
        return super.get(
            `${this.base}/store-featured-section-item-cover/{featuredSectionItemId}{?width,height}`,
            featuredSectionItemId,
            options
        );
    }
}

export default NakiStoreFeaturedSectionFileStreamApiRouteService;
